// extracted by mini-css-extract-plugin
export default {"wrap":"HeaderNFCS_wrap__fbEYT","generatedWrap":"HeaderNFCS_generatedWrap__PQBqB","generatedBolt":"HeaderNFCS_generatedBolt__nDDTV","line":"HeaderNFCS_line__bTKJK"};